import React, { useState } from 'react'
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react'
import './CalendarWidget.scss'

export const CalendarWidget: React.FC = () => {
  const [currentDate, setCurrentDate] = useState(new Date())

  // Get calendar data
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth()
  const monthNames = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ]
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  const firstDayOfMonth = new Date(year, month, 1).getDay()
  const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1 // Monday = 0

  const today = new Date()
  const isToday = (day: number) => {
    return today.getFullYear() === year &&
           today.getMonth() === month &&
           today.getDate() === day
  }

  // Mock events for demo
  const events: Record<number, number> = {
    5: 2,
    12: 1,
    15: 3,
    23: 1,
    28: 2
  }

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1))
  }

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1))
  }

  const handleToday = () => {
    setCurrentDate(new Date())
  }

  // Generate calendar days
  const days = []
  // Add empty cells for days before month starts
  for (let i = 0; i < adjustedFirstDay; i++) {
    days.push(<div key={`empty-${i}`} className="calendar-widget__day calendar-widget__day--empty" />)
  }
  // Add days of month
  for (let day = 1; day <= daysInMonth; day++) {
    const hasEvents = events[day] || 0
    days.push(
      <div
        key={day}
        className={`calendar-widget__day ${
          isToday(day) ? 'calendar-widget__day--today' : ''
        } ${hasEvents > 0 ? 'calendar-widget__day--has-events' : ''}`}
        title={hasEvents > 0 ? `${hasEvents} Aufgabe(n)` : undefined}
      >
        <span className="calendar-widget__day-number">{day}</span>
        {hasEvents > 0 && (
          <div className="calendar-widget__event-dots">
            {Array.from({ length: Math.min(hasEvents, 3) }).map((_, i) => (
              <span key={i} className="calendar-widget__event-dot" />
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="calendar-widget">
      <div className="calendar-widget__header">
        <Calendar size={16} />
        <span className="calendar-widget__title">Kalender</span>
      </div>

      <div className="calendar-widget__controls">
        <button
          className="calendar-widget__control-button"
          onClick={handlePrevMonth}
          title="Vorheriger Monat"
        >
          <ChevronLeft size={14} />
        </button>
        <button
          className="calendar-widget__month-year"
          onClick={handleToday}
          title="Heute"
        >
          {monthNames[month]} {year}
        </button>
        <button
          className="calendar-widget__control-button"
          onClick={handleNextMonth}
          title="Nächster Monat"
        >
          <ChevronRight size={14} />
        </button>
      </div>

      <div className="calendar-widget__weekdays">
        {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(day => (
          <div key={day} className="calendar-widget__weekday">
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-widget__days">
        {days}
      </div>

      <div className="calendar-widget__footer">
        <button className="calendar-widget__today-button" onClick={handleToday}>
          Heute: {today.getDate()}. {monthNames[today.getMonth()]}
        </button>
      </div>
    </div>
  )
}